import { selectors as siteSelectors } from 'modules/sites'
import { LOAD_SITE_SCHEDULES, SITE_SCHEDULE_ADDED, SITE_SCHEDULE_REMOVED } from './action-types'
// import { selectors as schedulesSelectors } from 'modules/schedules'
import { getFirstAccount } from 'modules/accounts'
import { firebaseDb } from 'modules/firebase'


// TODO: setup permission to get schedules info
export const loadSchedules = () => dispatch => {
  firebaseDb.ref('/schedules')
    .once('value')
    .then(snapshots => {
      let records = []
      let data = snapshots.val() || []

      Object.keys(data).forEach(key => {
        let record = data[key]
        record.key = key
        records.push(record)
      })

      dispatch({
        type: LOAD_SITE_SCHEDULES,
        payload: records
      })
    })
    .catch(err => { throw err })
}

const addSchedule = payload => ({ type: SITE_SCHEDULE_ADDED, payload })
const removeSchedule = payload => ({ type: SITE_SCHEDULE_REMOVED, payload })

export const setSiteSchedule = ({ cron, nextRun, key, remove }) => (dispatch, getState) => {
  const state = getState()
  const site = siteSelectors.getCurrentSiteId(state)
  const account = getFirstAccount(state).key
  const scheduleObject = remove ? null : { account, cron, nextRun, site }
  const scheduleKey = key || firebaseDb.ref('/schedules').push().key
  const actionPayload = { ...scheduleObject, key: scheduleKey }

  firebaseDb.ref(`/schedules/${scheduleKey}`)
    .set(scheduleObject)
    .then(() => {
      let action

      if (remove) {
        action = removeSchedule(actionPayload)
      }
      else {
        action = addSchedule(actionPayload)
      }

      dispatch(action)
    },
    err => { throw err }
    )
    .catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/modules/schedules/actions.js